import React, {Suspense, useState} from 'react';
import useIntersectionObserver from '@stencil/use-intersection-observer';
import {detailsNavigationIds} from '@stencil/hotels-utils/src/get-details-navigation-id-and-values';

import * as S from './Policy.styles';

const PolicyComponent = React.lazy(() => import('./Policy'));

const PolicyChunk = () => {
  return (
    <Suspense
      fallback={<S.PolicyListItemTextStyled>Loading Hotel Policy…</S.PolicyListItemTextStyled>}
    >
      <PolicyComponent />
    </Suspense>
  );
};

const intersectionObserverOptions = {
  root: null,
  threshHold: 0.01,
};

const Policy = () => {
  const [visible, setVisible] = useState(false);

  const [watcherRef] = useIntersectionObserver(intersectionObserverOptions, () => {
    setVisible(true);
  });
  return (
    <div ref={watcherRef} id={detailsNavigationIds.hotelPolicies}>
      {(visible && <PolicyChunk />) || null}
    </div>
  );
};

export default Policy;
